var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/activityfeed/viewmodels/index',["require", "exports", "models/account", "common/viewmodelbase", "areas/activityfeed/models/bindable", "services/trace", "areas/activityfeed/service/activityfeed-service"], function (require, exports, Account, Common, VM, traceSvc, service) {
    "use strict";
    var IndexViewModel = (function (_super) {
        __extends(IndexViewModel, _super);
        // #region ctor
        function IndexViewModel() {
            _super.call(this);
            this.activities = new Array();
            this.exceptionsMessage = "";
            this.hasActivities = false;
            this.calculatedTimelineBottom = false;
            // BroadcastChannel for cross-tab communication
            this._logoutBroadcastChannelName = "oneclick-logout-broadcast";
            this._logoutBroadcastChannel = null;
            this.title = "Activity feed";
            ko.track(this, ["activities", "url"]);
            this.url = "#/settings?source=1";
            this.activityfeedservice = new service.ActivityFeedService();
        }
        // #endregion
        // #region overrides
        IndexViewModel.prototype.onActivated = function (context) {
            //if (!this._initialized) {
            //    this._initialized = true;
            //    window.setTimeout(() => { this.loadData(); }, 200);
            //}    
            this.showCog = Account.Principal.current.memberType === 'client_postmaster';
            if (this.activities.length === 0) {
                this.loadData();
            }
            // Initialize cross-tab broadcast listener
            this.initializeBroadcastListener();
        };
        IndexViewModel.prototype.onDeactivated = function () {
            // Clean up broadcast listeners
            this.cleanupBroadcastListener();
        };
        // #endregion
        IndexViewModel.prototype.loadData = function () {
            var _this = this;
            this.activities = [];
            var self = this;
            this.activityfeedservice.getActivityFeedItems()
                .then(function (activityfeeditems) {
                activityfeeditems.activityVM.length != 0 ? _this.hasActivities = true : _this.hasActivities = false;
                if (_this.hasActivities) {
                    _this.activities = activityfeeditems.activityVM;
                }
                else {
                    _this.activities.removeAll(); // use-case: if the user press the refresh button many times quickly
                    var activityfeeditem = new VM.ActivityVM();
                    activityfeeditem.logoImage = "url('content/images/activity_feed_zero_state.png')";
                    activityfeeditem.timelineIcon = "fa fa-bell icon-blue activity-feed-bell";
                    _this.activities.push(activityfeeditem);
                }
                if (activityfeeditems.exceptions.length != 0) {
                    _this.exceptionsMessage = ""; // for page reload, this message will be cached
                    for (var i = 0; i < activityfeeditems.exceptions.length; i++) {
                        _this.exceptionsMessage = _this.exceptionsMessage + "\n" + activityfeeditems.exceptions[i];
                    }
                    traceSvc.traceInformation(_this.exceptionsMessage);
                }
            });
        };
        IndexViewModel.prototype.lengthenTimeline = function () {
            if (!this.calculatedTimelineBottom) {
                var timeline = document.getElementById("activity-feed-timeline");
                $('body').append('<style>.activity-feed-timeline:before{top:0;bottom:-' + (timeline.scrollHeight - timeline.clientHeight) +
                    'px;position:absolute;content:" ";width:1px;background-color:#ccc;left:30px}</style>');
                this.calculatedTimelineBottom = true;
            }
        };
        // #region BroadcastChannel implementation
        IndexViewModel.prototype.initializeBroadcastListener = function () {
            var _this = this;
            try {
                if (typeof window.BroadcastChannel !== 'undefined') {
                    this._logoutBroadcastChannel = new window.BroadcastChannel(this._logoutBroadcastChannelName);
                    this._logoutBroadcastChannel.onmessage = function (event) {
                        if (event.data && event.data.type === 'logout') {
                            traceSvc.traceInformation("Activity Feed: Logout triggered from another tab");
                            _this.activities.removeAll();
                        }
                    };
                }
            }
            catch (error) {
                console.error("[ActivityFeed] Error initializing broadcast listener:", error);
                traceSvc.traceError("Activity Feed: Error initializing broadcast listener", error, "", true);
            }
        };
        IndexViewModel.prototype.cleanupBroadcastListener = function () {
            try {
                if (this._logoutBroadcastChannel) {
                    this._logoutBroadcastChannel.close();
                    this._logoutBroadcastChannel = null;
                }
            }
            catch (error) {
                console.error("[ActivityFeed] Error cleaning up broadcast listener:", error);
                traceSvc.traceError("Activity Feed: Error cleaning up broadcast listener", error, "", true);
            }
        };
        return IndexViewModel;
    }(Common.ListViewModelBase));
    var instance = new IndexViewModel();
    return instance;
});

